module.exports = __webpack_public_path__ + "assets/img/banner3.ccb6d3a1.jpg";